import WheatPastaProduct from 'models/WheatPastaProduct'

export const packagingInitialState = {
  category: WheatPastaProduct.category,
  subCategory: WheatPastaProduct.subCategory,
  WholeWheatFlour: WheatPastaProduct.WholeWheatFlour,
  PastaShape: WheatPastaProduct.PastaShape,
  Size: WheatPastaProduct.Size,
}
